<template>
    <div class="three">
        <a href="https://weix2.hengdianworld.com/redirect?type=activity&id=316"><img src="../images/cp3.png" class="swiper-img"/></a>
        <Title>
            <template v-slot:index>
                <div class="t1">
                    <span class="index">1</span>
                    <span class="big-font">走进实景课堂</span>--带你梦回千年
                </div>
            </template>
            <template v-slot:xc>
                <div class="t2">
                    火烧圆明园 暴雨山洪 梦幻太极 八旗马战 紫金大典 ...
                </div>
            </template>
        </Title>
        <div class="cover-box">
            <div class="content-box">
                《火烧圆明园》--一场世界演艺史上恢弘的“大火”，将烧进我们的内心。
            </div>
            <img src="../images/three/t1.png" alt="" class="one-img"></div>
        <div class="two-items">
            <div class="cover-box">
                <div class="content-box">
                    秦王宫--《英雄比剑》
                </div>
                <img src="../images/three/t2.png" alt="" class="two-img"></div>
            <div class="cover-box">
                <div class="content-box">
                    清明上河图--《汴梁一梦》
                </div>
                <img src="../images/three/t22.png" alt="" class="two-img"></div>
        </div>
        <div class="cover-box">
            <div class="content-box">
                梦幻谷--傩舞大秀《暴雨山洪》、阴阳五行学《梦幻太极》
            </div>
            <img src="../images/three/t3.png" alt="" class="one-img"></div>
        <Title>
            <template v-slot:index>
                <div class="t1">
                    <span class="index">2</span>
                    <span class="big-font">玩转游乐场</span>--夜游主题公园
                </div>
            </template>
            <template v-slot:xc>
                <div class="t2">
                    儿童梦工厂 亚马快车 喜马天轮 吉祥木马 疯狂马戏团...
                </div>
            </template>
        </Title>
        <div class="cover-box">
            <div class="content-box">
                30余项游乐设施，好玩又刺激，嗨爆！
            </div>
            <img src="../images/three/t4.png" alt="" class="one-img"></div>
        <div class="two-items">
            <div class="cover-box">
                <div class="content-box">
                    太空梭
                </div>
                <img src="../images/three/t5.png" alt="" class="two-img"></div>
            <div class="cover-box">
                <div class="content-box">
                    疯狂马戏团
                </div>
                <img src="../images/three/t55.png" alt="" class="two-img"></div>
        </div>
        <Title>
            <template v-slot:index>
                <div class="t1">
                    <span class="index">3</span>
                    <span class="big-font">追寻网红打卡点</span>--经典景区
                </div>
            </template>
            <template v-slot:xc>
                <div class="t2">
                    主要景点：清明上河图、明清宫苑、秦王宫、圆明新园
                </div>
            </template>
        </Title>
        <img src="../images/three/t6.png" alt="" class="one-img">
        <div class="two-items">
            <img src="../images/three/t7.png" alt="" class="two-img">
            <img src="../images/three/t77.png" alt="" class="two-img">
        </div>
        <div class="two-items">
            <img src="../images/three/t8.png" alt="" class="two-img">
            <img src="../images/three/t88.png" alt="" class="two-img">
        </div>
        <Title>
            <template v-slot:index>
                <div class="t1">
                    <span class="index">4</span>
                    <span class="big-font">影视拍摄体验</span>--自己做演员
                </div>
            </template>
            <template v-slot:xc>
                <div class="t2">
                    清明上河图、明清宫苑景区均可体验拍摄的乐趣
                </div>
            </template>
        </Title>
        <img src="../images/three/t9.png" alt="" class="one-img">
        <div class="two-items">
            <img src="../images/three/r1.png" alt="" class="two-img">
            <img src="../images/three/r11.png" alt="" class="two-img">
        </div>
        <div class="two-items">
            <img src="../images/three/r2.png" alt="" class="two-img">
            <img src="../images/three/r22.png" alt="" class="two-img">
        </div>
        <Title>
            <template v-slot:index>
                <div class="t1">
                    <span class="index">5</span>
                    入住广州街影视主题精品酒店
                </div>
            </template>
            <template v-slot:xc>
                <div class="t2">
                    <span class="xc">秋季行程</span>免费租一套古装 夜游19世纪香港维多利亚港...
                </div>
            </template>
        </Title>
        <div class="cover-box">
            <div class="content-box">
                夜幕降临 华灯初放 带你住在剧中 穿越回老香港...
            </div>
            <img src="../images/three/r3.png" alt="" class="one-img"></div>
        <div class="two-items">
            <div class="cover-box">
                <div class="content-box">
                    古装免费租
                </div>
                <img src="../images/three/r4.png" alt="" class="two-img"></div>
            <img src="../images/three/r44.png" alt="" class="two-img">
        </div>
        <img src="../images/three/r5.png" alt="" class="one-img">
        <div class="two-items">
            <img src="../images/three/r6.png" alt="" class="two-img">
            <img src="../images/three/r66.png" alt="" class="two-img">
        </div>
    </div>
</template>

<script>
    import Title from '../components/Title'
    export default {
        components: {
            Title,
        }
    }
</script>

<style lang="stylus" scoped>
    .three
        display flex
        flex-direction column
        align-items center
        background-color #CEAEA5
        .two-items
            display flex
            justify-content space-between
            width 92.8vw

</style>